<template>
    <div>
        <a-modal
            v-model="tagsVisible"
            @cancel="cancelModal"
            :maskClosable="false"
            :title="$t('message.addUserGroup.MyTags')"
            :footer="null"
            width="1300px"
        >
            <a-form-model layout="inline" :model="searchForm">
                <a-row :gutter="32">
                    <a-col class="gutter-row" :span="8">
                        <a-form-model-item :label="$t('message.addUserGroup.TagID')">
                            <a-input :size="$globalSize" v-model.trim="searchForm.code" :placeholder="$t('message.addUserGroup.EnterTagID')" allowClear />
                        </a-form-model-item>
                    </a-col>
                    <a-col class="gutter-row" :span="8">
                        <a-form-model-item :label="$t('message.addUserGroup.ChineseTagName')"> 
                            <a-input :size="$globalSize" v-model.trim="searchForm.name" :placeholder="$t('message.addUserGroup.EnterChineseTagName')" allowClear />
                        </a-form-model-item>
                    </a-col>
                    <a-col class="gutter-row" :span="8">
                        <a-form-model-item>
                            <a-button  :size="$globalSize"  type="primary" @click="tagSearch"> {{ $t('message.addUserGroup.search') }} </a-button>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
            
            <div class="tags-container">
                <div class="left-container">
                    <h3 class="bolder">{{ $t('message.addUserGroup.TagDisplay') }}</h3> 
                    <a-spin :spinning="tagTreeSpinning" class="tree-spinning-container">
                        <a-tree
                            v-if="tagsTreeData.length>0"
                            :show-line="true"
                            :tree-data="tagsTreeData"
                            :defaultSelectedKeys="defaultSelectedKeys"
                            :defaultExpandedKeys="defaultExpandedKeys"
                            @select="onSelect"
                        />
                    </a-spin>
                </div>
                <div class="right-container">
                    <h3 class="bolder">{{ $t('message.addUserGroup.TagList') }}</h3>
                    <a-table
                        bordered
                        rowKey="id"
                        :data-source="dataSource"
                        :columns="columns"
                        :pagination="pagination"
                        :loading="loadingTable"
                    >
                        <template slot="fav_status" slot-scope="text, record">
                            <a-switch v-model="text" @click="changeFavStatus(text,record.id)" />
                        </template>
                    </a-table>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>
import tagManagementService from "@/interface/pages/Tag/tagManagement";
import myTagsService from '@/interface/pages/Tag/myTags.js';

export default {
  name: "MyTag", // 我的标签
  created() {
    this.tagsVisible = true
    this.getTagTreeMenu()
  },
  data() {
    return {
        tagsVisible: true,
        searchForm: {
            code: '',
            name: ''
        },
        tagTreeSpinning: false,
        tagsTreeData: [],
        defaultSelectedKeys: [],
        defaultExpandedKeys: [],
        selectedKey: '',
        pagination: {
            defaultPageSize: 8, // 默认当前页数据量
            showTotal: (total) => `${this.$t('message.commonUsage.total')} ${ this.dataSource.length } ${this.$t('message.commonUsage.records')}`, //数据总量
            showSizeChanger: true, //显示当前页数据量改变
            pageSizeOptions: ['5','8', '10', '15'], //页容量显示
            onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize),
            showQuickJumper: true // 显示跳转
        },
        loadingTable: false,
        dataSource: [],
        columns: [
            { title: 'ID', dataIndex: 'id', width: 100 },
            { title: ()=> this.$t('message.addUserGroup.TagID'), dataIndex: 'dim_code' },
            { title: ()=> this.$t('message.addUserGroup.Tag'), dataIndex: 'dim_name_cn' },
            { title: ()=> this.$t('message.addUserGroup.Favorite'), dataIndex: 'fav_status', scopedSlots: { customRender: 'fav_status' } }
        ]
    }
  },
  methods: {
    cancelModal() {
        this.$emit('destoryMyTags')
    },
    tagSearch() {
        this.searchList(this.searchForm)
    },
    searchList(params) {
        this.loadingTable = true
        this.dataSource = []
        myTagsService.getFavTagsByName(this, { params: params })
        .then(
            response => {
                let res = response.data
                if(res.code === '200') {
                    this.dataSource = res.data
                }
            }
        )
        .finally(() => {
            this.loadingTable = false
        })
    },
    getTagTreeMenu() {
        this.spinningTreeMenu = true
        let body = {};
        tagManagementService.getFitlerMyTagTree(this, {params: body})
        .then(
            function (response) {
                let res = response.data;
                if (res.code === "200") {
                    this.tagsTreeData = res.data;
                    this.tagsTreeData.forEach(item => {
                        item.children.forEach(childItem => {
                            childItem.children.forEach(leaf => {
                                leaf.isLeaf = true
                            })
                        })
                    })
                    
                    const defaultKey = this.tagsTreeData[0].children[0].children[0].key
                    this.defaultSelectedKeys.push(defaultKey)
                    this.defaultExpandedKeys.push(defaultKey)
                    this.spinningTreeMenu = false
                    this.getFavTagsByLevel(defaultKey)
                    this.selectedKey = defaultKey
                }
            }.bind(this)
        )
        .catch((response) => {
            console.log(response);
        });
    },
    getFavTagsByLevel(defaultKey) {
        this.dataSource = []
        const body = { level: defaultKey }
        myTagsService.getFavTagsByLevel(this, { params: body })
        .then(
            function(response) {
                let res = response.data;
                if(res.code === '200') {
                    this.dataSource = res.data
                }
            }.bind(this)
        )
    },
    onSelect(selectedKeys, info) {
        const isLeaf = info.node.isLeaf
        const selectedKey = selectedKeys[0]
        if(isLeaf) {
            this.selectedKey = selectedKey
            this.getFavTagsByLevel(selectedKey)
        }
    },
    updateFavTag(status, id,resolve=(()=>{})) {
        const body = {
            id,
            fav_status: status
        }
        // 刷新列表 更新收藏状态
        myTagsService.updateFavTag(this, { params: body })
        .then(response => {
            let res = response.data;
            if (res.code === "200") {
                this.$message.success(res.message);
                resolve()
                this.getFavTagsByLevel(this.selectedKey)
                this.$emit('updateTags')
            } else {
                this.$message.error(res.message);
            }
        })
        .catch((response) => {
            console.log(response);
        });
    },
    changeFavStatus(status, id) {
        let _self = this
        if(status) { // true 收藏
            this.$confirm({
                content: this.$t('message.addUserGroup.IfBookmark'),
                onOk() {
                    return new Promise((resolve, reject) => {
                        _self.updateFavTag(1, id,resolve)
                    })
                },
                okText: this.$t('message.addUserGroup.Confirm'),
                cancelText: this.$t('message.addUserGroup.Cancel'),
                onCancel() {},
            });
        } else { // false 取消收藏
            this.$confirm({
                content: this.$t('message.addUserGroup.CancelBookmarking'),
                onOk() {
                    return new Promise((resolve, reject) => {
                        _self.updateFavTag(0, id,resolve)
                    })
                },
                okText: this.$t('message.addUserGroup.Confirm'),
                cancelText: this.$t('message.addUserGroup.Cancel'),
                onCancel() {},
            });
        }
    }
  }
}
</script>
<style scoped>
    .tags-container {
        margin: 20px 0;
    }
    .left-container {
        display: inline-block;
        width: 27%;
        vertical-align: top;
    }
    .right-container {
        display: inline-block;
        width: 73%;
        vertical-align: top;
    }
    .bolder {
        font-weight: bold;
    }
    .tree-spinning-container {
        min-height: 200px;
    }
</style>